const queryKeysSchema = [
  'activeDataProviderChannels',
  'activeEnforcementListingIds',
  'addItemNumberToProduct',
  'authenticationMethods',
  'availableStores',
  'bot',
  'botRun',
  'botRunLogFile',
  'botRuns',
  'bots',
  'brand',
  'branding',
  'brands',
  'channel',
  'channels',
  'companies',
  'companiesCountCsv',
  'companiesCsv',
  'companiesNiceClassesCsv',
  'companiesRegistrationsCsv',
  'company',
  'companyPayments',
  'companyStore',
  'companyStores',
  'companyStoresCsv',
  'companyTrademarks',
  'companyUsers',
  'costControl',
  'refControl',
  'costControls',
  'refControls',
  'countries',
  'currencies',
  'currency',
  'dataProvider',
  'distributor',
  'distributors',
  'distributorStore',
  'distributorStores',
  'distributorStoreInvoices',
  'distributorInvoicePreview',
  'distributorSuggestion',
  'distributorSuggestionMatches',
  'distributorSuggestions',
  'dataProviders',
  'dataProviderSubdomains',
  'enforceableAreas',
  'enforcement',
  'enforcementActionTypes',
  'enforcementAuditTrails',
  'enforcementComments',
  'enforcementConversations',
  'enforcementInfringementTypes',
  'enforcementPolicies',
  'enforcementPoliciesPdf',
  'enforcementPolicyDefinition',
  'enforcementPolicyDefinitions',
  'enforcements',
  'enforcementsCsv',
  'enforcementStatuses',
  'enforcementTypes',
  'enforcementWebform',
  'enforcementProductImages',
  'enforcementProductContent',
  'importProducts',
  'inAppNotifications',
  'inAppNotificationsPage',
  'keymetrics',
  'keyword',
  'keywordAssociatedBots',
  'keywords',
  'listing',
  'listingProductMatches',
  'listings',
  'listingsCsv',
  'loa',
  'loas',
  'manualStores',
  'manualTestPurchase',
  'manualTestPurchases',
  'mapControl',
  'mapControls',
  'mentionableUsers',
  'msrpControl',
  'msrpControls',
  'niceClass',
  'niceClasses',
  'notificationTemplate',
  'notificationTemplates',
  'policyTypes',
  'pricingPoliciesCsv',
  'product',
  'productAssociatedProductItemNumbers',
  'productImages',
  'productContent',
  'trustedSources',
  'productItemNumbers',
  'productItemNumbersCsv',
  'trustedSourcesCsv',
  'productImagesCsv',
  'productContentCsv',
  'products',
  'productsCsv',
  'report',
  'reports',
  'reseller',
  'resellers',
  'secureFeatureFlagContext',
  'store',
  'storeBusinessTypes',
  'stores',
  'storesCsv',
  'subdomain',
  'subdomainDataProvider',
  'subdomains',
  'supportTeam',
  'testPurchase',
  'testPurchases',
  'testPurchasesCsv',
  'testPurchaseStatuses',
  'trackedPrices',
  'trackedPricesSummary',
  'trackedPricesFacets',
  'trackedPriceMovementTimeSeries',
  'trackedPriceFacetOptions',
  'trackedPriceMovements',
  'trackedPriceMonitoredItems',
  'trackedPriceBenchmarkBreaches',
  'trackedPriceReferencePrices',
  'trademark',
  'trademarkOffice',
  'trademarkOffices',
  'trademarkType',
  'trademarkTypes',
  'user',
  'userRoles',
  'verificationFeeTransactions',
] as const;

type QueryKeysType = typeof queryKeysSchema[number];

const createObjectFromKeys = <T extends QueryKeysType>(arr: readonly T[]) =>
  arr.reduce((acc, item) => {
    acc[item] = item;
    return acc;
  }, {} as Record<T, T>);

export const QUERY_KEYS = createObjectFromKeys(queryKeysSchema);
